import response from '../response.js';
import {pythonGenerator} from 'blockly/python';
import {javascriptGenerator} from 'blockly/javascript';
import Blockly from 'blockly/core';

pythonGenerator['temperatures'] = function (block) {
    var temp = [];
    for (var i = 0; i < response.events.length; i++) {
        temp.push(response.events[i].body.temperature)
    }
    const code = '[' + String(temp) + ']';
    return [code, pythonGenerator.ORDER_FUNCTION_CALL];
};

pythonGenerator['aqi'] = function (block) {
    var aqi = [];
    for (var i = 0; i < response.events.length; i++) {
        aqi.push(response.events[i].body.aqi)
    }
    const code = '[' + String(aqi) + ']';
    return [code, pythonGenerator.ORDER_FUNCTION_CALL];
};

pythonGenerator['humidity'] = function (block) {
    var humidity = [];
    for (var i = 0; i < response.events.length; i++) {
        humidity.push(response.events[i].body.humidity)
    }
    const code = '[' + String(humidity) + ']';
    return [code, pythonGenerator.ORDER_FUNCTION_CALL];
};

javascriptGenerator['temperatures'] = function (block) {
    var temp = [];
    for (var i = 0; i < response.events.length; i++) {
        temp.push(response.events[i].body.temperature)
    }
    const code = '[' + String(temp) + ']';
    return [code, javascriptGenerator.ORDER_FUNCTION_CALL];
};

javascriptGenerator['aqi'] = function (block) {
    var aqi = [];
    for (var i = 0; i < response.events.length; i++) {
        aqi.push(response.events[i].body.aqi)
    }
    const code = '[' + String(aqi) + ']';
    return [code, javascriptGenerator.ORDER_FUNCTION_CALL];
};

javascriptGenerator['humidity'] = function (block) {
    var humidity = [];
    for (var i = 0; i < response.events.length; i++) {
        humidity.push(response.events[i].body.humidity)
    }
    const code = '[' + String(humidity) + ']';
    return [code, javascriptGenerator.ORDER_FUNCTION_CALL];
};

pythonGenerator['graph'] = function(block) {
    var value_title = pythonGenerator.valueToCode(block, 'title', pythonGenerator.ORDER_ATOMIC);
    var value_x = pythonGenerator.valueToCode(block, 'X', pythonGenerator.ORDER_ATOMIC);
    var value_y = pythonGenerator.valueToCode(block, 'Y', pythonGenerator.ORDER_ATOMIC);
    var text_x = block.getFieldValue('X');
    var text_y = block.getFieldValue('Y');
    // TODO: Assemble Python into code variable.
    var code = 'import matplotlib.pyplot as plt' + '\n' 
    + 'plt.plot(' + value_x + "," + value_y + ')' + '\n' 
    + 'plt.title(' + '"' + value_title + '"' + ')' + '\n' 
    + 'plt.xaxis(' + '"' + text_x + '"' + ')' + '\n' 
    + 'plt.yaxis(' + '"' + text_y + '"' + ')' + '\n' 
    ;
    return code;
};

javascriptGenerator['graph'] = function(block) {
    var value_title = javascriptGenerator.valueToCode(block, 'title', javascriptGenerator.ORDER_ATOMIC);
    var value_x = javascriptGenerator.valueToCode(block, 'X', javascriptGenerator.ORDER_ATOMIC);
    var value_y = javascriptGenerator.valueToCode(block, 'Y', javascriptGenerator.ORDER_ATOMIC);
    var text_x = block.getFieldValue('X');
    var text_y = block.getFieldValue('Y');
    // TODO: Assemble JavaScript into code variable.
   
    var code = 'trace = {' + '\n' +
    'x:' + String(value_x) + "," + '\n' +
    'y:' + String(value_y) + "," + '\n' +
    'mode: "markers",' + '\n' +
    'type: "scatter"' + '\n' +
    '};' + '\n' +
    `layout = { ` + '\n' +
    'title:' + '"' + value_title + '",' + '\n' +
    'xaxis: {title: ' + '"' + text_x + '"' +'},' + '\n' + 
    'yaxis: {title: ' + '"' + text_y + '"' +'},' + '\n' + 
    '};';
    return code;
};
